const helpers = require('./modules/helpers');

class tooltip {
  constructor(element, options) {
    this.options = helpers.privateMethods.extend({
      position: 'bottom',
      content: null,
      type: 'hover',
      boundingElement: null,
      onCreate: null,
      onOpen: null,
      onClose: null,
      noPad: false,
      closeButton: false,
      bestPosition: true,
      width: 'medium',
      closeOnClick: false,
      scrollCompatable: false
    }, options);
    this.$element = element;
    this.bounder = this.options.boundingElement;
    const data = helpers.privateMethods.datareturntooltipid();
    if (!this.id) {
      this.id = helpers.privateMethods.createToolTipId();
      data.set(this.$element, { tooltipid: this.id });
    }
    this.id = data.get(this.$element).tooltipid;
    this.$tooltip = null;
    this.init();
    helpers.privateMethods.addTooltip(this);
  }

  init() {
    const element = this.$tooltip;
    if (this.options.type === 'hover') {
      this.$element.addEventListener('mouseover', this._open.bind(this));
      this.$element.addEventListener('mouseleave', this._close.bind(this));
    }
    if (this.options.type === 'click') {
      this.$element.addEventListener('click', this._toggle.bind(this));
      // this.$element.addEventListener('touchend', this._toggle.bind(this));
    }
    return this;
  }

  _createTooltip() {
    helpers.mainid = this.id;
    helpers.position = this.options.position;
    const tooltipHtml = `<div id="${helpers.mainid}" class="ToolTip ToolTip--${helpers.position}"><div class="ToolTip__arrow ToolTip__arrow--${helpers.position}"></div><div class="ToolTip__wrapper ToolTip__wrapper--${helpers.position}"><div class="ToolTip__closebutton"></div><div class="ToolTip__content ToolTip__content--${helpers.position}" /></div></div>`;
    const envelope = document.createElement('div');
    this.addClass(envelope, 'Envelope');
    document.body.appendChild(envelope);
    envelope.innerHTML = tooltipHtml;
    const $tooltip = envelope.querySelector('.ToolTip');
    const $tooltipArrow = $tooltip.querySelector('.ToolTip__arrow');
    const $tooltipWrapper = $tooltip.querySelector('.ToolTip__wrapper');
    const $tooltipContent = $tooltip.querySelector('.ToolTip__content');
    const $tooltipClose = $tooltip.querySelector('.ToolTip__closebutton');
    this.toggleClass($tooltipContent, 'ToolTip__content--no-pad', this.options.noPad);
    if (typeof this.options.pixelWidth === 'undefined') {
      this.addClass($tooltipWrapper, `ToolTip--${this.options.width}`);
    } else {
      $tooltipWrapper.style.width = `${+this.options.pixelWidth}px`;
    }
    if (!this.options.closeButton) {
      helpers.privateMethods.removeNode($tooltipClose);
    } else {
      $tooltipClose.addEventListener('click', this._toggle.bind(this));
    }
    const data = helpers.privateMethods.datareturncontent();
    if (this.options.content && (typeof this.options.content === 'function')) {
      const content = this.options.content();
      if (typeof content === 'object') {
        $tooltipContent.appendChild(content);
      } else {
        $tooltipContent.innerHTML = content;
      }
    } else if (this.options.content) {
      $tooltipContent.innerHTML = this.options.content;
    } else if (this.options.onCreate) {
      this.options.onCreate($tooltipContent);
    } else {
      $tooltipContent.innerHTML = this.$element.dataset.content;
    }
    this._resize($tooltip);
    this.addClass($tooltip, 'ToolTip--closed');
    this.addClass($tooltipWrapper, 'ToolTip__wrapper--closed');
    this.addClass($tooltipArrow, 'ToolTip__arrow--closed');
    // document.body.appendChild($tooltip);
    if (this.options.scrollCompatable)
      this.$element.parentNode.insertBefore($tooltip, this.$element.nextSibling);
    else
      document.body.appendChild($tooltip);
    envelope.parentNode.removeChild(envelope);
    return $tooltip;
  }

  addClass(el, className) {
    if (el.classList)
      el.classList.add(className);
    else
      el.className += ` ${className}`;
  }

  removeClass(el, className) {
    if (el.classList)
      el.classList.remove(className);
    // else
    //   el.className = el.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
  }

  toggleClass(el, className, noPad) {
    if (el.classList) {
      el.classList.toggle(className, noPad);
    }
    // else {
    //   const classes = el.className.split(' ');
    //   const existingIndex = classes.indexOf(className);
    //   if (existingIndex >= 0)
    //     classes.splice(existingIndex, 1);
    //   else
    //     classes.push(className);
    //
    //   el.className = classes.join(' ');
    // }
  }

  getPosition(elm) {
    let xPos = 0;
    let yPos = 0;
    while (elm) {
      xPos += (elm.offsetLeft - elm.scrollLeft + elm.clientLeft);
      yPos += (elm.offsetTop - elm.scrollTop + elm.clientTop);
      elm = elm.offsetParent;
    }
    return { x: xPos, y: yPos };
  }

  parents(element) {
    const parents = [];
    while (element.parentElement) {
      parents.push(element = element.parentElement);
    }
    return parents;
  }

  _windowDimensions() {
    const $sizer = document.createElement('div');
    this.addClass($sizer, 'Sizer');
    document.body.appendChild($sizer);
    const windowData = this._elementDimensions($sizer);
    helpers.privateMethods.removeNode($sizer);
    return windowData;
  }

  _elementDimensions($element) {
    const rect = this.getPosition($element);
    const offset = {
      top: rect.y + document.body.scrollTop,
      left: rect.x + document.body.scrollLeft
    };
    const elementWidth = $element.offsetWidth;
    const elementHeight = $element.offsetHeight;
    let elementData = {
      width: elementWidth,
      height: elementHeight,
      bottom: offset.top + elementHeight,
      right: offset.left + elementWidth,
      top: offset.top,
      left: offset.left
    };
    return elementData;
  }

  _setOrientation(orientation) {
    this.removeClass(this.$tooltip, 'ToolTip--bottom');
    this.removeClass(this.$tooltip, 'ToolTip--top');
    this.removeClass(this.$tooltip, 'ToolTip--left');
    this.removeClass(this.$tooltip, 'ToolTip--right');
    this.addClass(this.$tooltip, `ToolTip--${orientation}`);
    const tooltipwrapper = this.$tooltip.querySelector('.ToolTip__wrapper');
    this.removeClass(tooltipwrapper, 'ToolTip__wrapper--bottom');
    this.removeClass(tooltipwrapper, 'ToolTip__wrapper--top');
    this.removeClass(tooltipwrapper, 'ToolTip__wrapper--left');
    this.removeClass(tooltipwrapper, 'ToolTip__wrapper--right');
    this.addClass(tooltipwrapper, `ToolTip__wrapper--${orientation}`);
    const tooltipcontent = tooltipwrapper.querySelector('.ToolTip__content');
    this.removeClass(tooltipcontent, 'ToolTip__content--bottom');
    this.removeClass(tooltipcontent, 'ToolTip__content--top');
    this.removeClass(tooltipcontent, 'ToolTip__content--left');
    this.removeClass(tooltipcontent, 'ToolTip__content--right');
    this.addClass(tooltipcontent, `ToolTip__content--${orientation}`);
    const tooltiparrow = this.$tooltip.querySelector('.ToolTip__arrow');
    this.removeClass(tooltiparrow, 'ToolTip__arrow--bottom');
    this.removeClass(tooltiparrow, 'ToolTip__arrow--top');
    this.removeClass(tooltiparrow, 'ToolTip__arrow--left');
    this.removeClass(tooltiparrow, 'ToolTip__arrow--right');
    this.addClass(tooltiparrow, `ToolTip__arrow--${orientation}`);
  }

  _positionTooltip() {
    if (!this[this.options.position]) {
      throw new Error('Hello');
    }

    const position = this[this.options.position]();
    this.$tooltip.style.top = (typeof position.tooltip.top !== 'undefined') ? `${position.tooltip.top}px` : 'auto';
    this.$tooltip.style.bottom = (typeof position.tooltip.bottom !== 'undefined') ? `${position.tooltip.bottom}px` : 'auto';
    this.$tooltip.style.left = (typeof position.tooltip.left !== 'undefined') ? `${position.tooltip.left}px` : 'auto';
    this.$tooltip.style.right = (typeof position.tooltip.right !== 'undefined') ? `${position.tooltip.right}px` : 'auto';
    const tooltiparrow = this.$tooltip.querySelector('.ToolTip__arrow');
    tooltiparrow.style.marginTop = (typeof position.arrow.top !== 'undefined') ? `${position.arrow.top - 10}px` : '0';
    tooltiparrow.style.marginLeft = (typeof position.arrow.left !== 'undefined') ? `${position.arrow.left - 10}px` : '0';
  }

  _documentClickListner(event) {
    const $el = event.target;
    const parents = this.parents($el);
    if (!parents.length) return;
    const isTooltipDiv = parents.some(p => {
      return p.classList.contains('ToolTip');
    });
    if (isTooltipDiv) return;
    document.removeEventListener('click', this._documentClickListner);
    this._close();
  }

  _calculatePosition(orientation, windowData, targetData, boxData) {
    this._setOrientation(orientation);
    const tooltipData = this._elementDimensions(this.$tooltip);
    return this[`_${orientation}Position`](windowData, targetData, tooltipData, boxData);
  }

  _getWidth() {
    const PADDING = 20;
    if (this.options.pixelWidth) return +this.options.pixelWidth;
    switch (this.options.width) {
      case 'small':
        return 200 + PADDING;
      case 'medium':
        return 320 + PADDING;
      case 'large':
        return 500 + PADDING;
      default:
        return 320 + PADDING;
    }
  }

  _bottomPosition(windowData, target, tooltip, bounds) {
    const canFitWithinVerticalBounds = ((target.bottom + tooltip.height) < bounds.bottom);
    if (!canFitWithinVerticalBounds && this.options.bestPosition) {
      return;
    }
    const targetCenter = (target.left + (target.width / 2));
    const offsetLeft = (targetCenter - (tooltip.width / 2));
    const maxLeft = (bounds.right - tooltip.width);
    const boundedOffsetLeft = Math.min(maxLeft, Math.max(bounds.left, offsetLeft));
    const bottomPositionObject = {
      orientation: 'bottom',
      tooltip: {
        top: (target.top + target.height),
        left: boundedOffsetLeft + (this.options.horizontalOffset ? this.options.horizontalOffset : 0)
      },
      arrow: {
        left: offsetLeft - boundedOffsetLeft
      }
    };
    if (this.options.scrollCompatable) {
      delete bottomPositionObject.tooltip.top;
      bottomPositionObject.tooltip.left = bottomPositionObject.tooltip.left - target.left;
    }
    return bottomPositionObject;
  }

  _topPosition(windowData, target, tooltip, bounds) {
    const canFitWithinVerticalBounds = (tooltip.height < (target.top - bounds.top));
    if (!canFitWithinVerticalBounds && this.options.bestPosition) {
      return;
    }
    const targetCenter = (target.left + (target.width / 2));
    const offsetLeft = (targetCenter - (tooltip.width / 2));
    const maxLeft = (bounds.right - tooltip.width);
    const boundedOffsetLeft = Math.min(maxLeft, Math.max(bounds.left, offsetLeft));
    const bottomPositionObject = {
      orientation: 'top',
      tooltip: {
        bottom: bounds.bottom - target.top,
        left: boundedOffsetLeft + (this.options.horizontalOffset ? this.options.horizontalOffset : 0)
      },
      arrow: {
        left: offsetLeft - boundedOffsetLeft
      }
    };
    if (this.options.scrollCompatable) {
      bottomPositionObject.tooltip.left = bottomPositionObject.tooltip.left - target.left;
      bottomPositionObject.tooltip.bottom = target.height + tooltip.height;
    }
    return bottomPositionObject;
  }

  _rightPosition(windowData, target, tooltip, bounds) {
    const canFitWithinHorizontalBounds = (this._getWidth() < (bounds.right - target.right));
    if (!canFitWithinHorizontalBounds && this.options.bestPosition) {
      return;
    }
    const targetMiddle = (target.top + (target.height / 2));
    const offsetTop = (targetMiddle - (tooltip.height / 2));
    const boundedOffsetTop = Math.max(bounds.top, offsetTop);
    const boundedOffsetTopArrow = offsetTop > 0 ? (boundedOffsetTop - offsetTop) : (boundedOffsetTop + offsetTop)
    const bottomPositionObject = {
      orientation: 'right',
      tooltip: {
        top: boundedOffsetTop,
        left: target.right + (this.options.horizontalOffset ? this.options.horizontalOffset : 0)
      },
      arrow: {
        top: boundedOffsetTopArrow
      }
    };
    if (this.options.scrollCompatable) {
      bottomPositionObject.tooltip.left = target.width;
      bottomPositionObject.tooltip.top = bottomPositionObject.tooltip.top - target.top;
    }
    return bottomPositionObject;
  }

  _leftPosition(windowData, target, tooltip, bounds) {
    const canFitWithinHorizontalBounds = (this._getWidth() < (target.left - bounds.left));
    if (!canFitWithinHorizontalBounds && this.options.bestPosition) {
      return;
    }
    const targetMiddle = (target.top + (target.height / 2));
    const offsetTop = (targetMiddle - (tooltip.height / 2));
    const maxTop = (bounds.bottom - tooltip.height);
    const boundedOffsetTop = Math.min(maxTop, Math.max(bounds.top, offsetTop));
    const bottomPositionObject = {
      orientation: 'left',
      tooltip: {
        top: boundedOffsetTop,
        right: bounds.width - target.left + (this.options.horizontalOffset ? this.options.horizontalOffset : 0)
      },
      arrow: {
        top: offsetTop - boundedOffsetTop
      }
    };
    if (this.options.scrollCompatable) {
      bottomPositionObject.tooltip.right = tooltip.right + target.width;
      bottomPositionObject.tooltip.top = bottomPositionObject.tooltip.top - target.top;
    }

    return bottomPositionObject;
  }

  _bestPosition(orientationPreferences) {
    let windowData = this._windowDimensions();
    let boxData = (this.options.boundingElement) ? this._elementDimensions(this.options.boundingElement) : windowData;
    let elementData = this._elementDimensions(this.$element);
    let position = '';
    let bestPosition = '';
    for (let x = 0; x < orientationPreferences.length; x++) {
      position = this._calculatePosition(orientationPreferences[x], windowData, elementData, boxData);
      if (position) {
        bestPosition = position;
        break;
      }
    }
    return bestPosition;
  }

  _selectPosition(orientationPreferences) {
    const position = this._bestPosition(orientationPreferences);
    if (!position) {
      console.log('Error, could not position tooltip successfully');
    }
    return position;
  }

  hide() {
    const that = this;
    this.$tooltip.style.display = 'none';
    this._close();
    setTimeout(() => {
      that.$tooltip.style.display = '';
    }, 300);
  }

  update(el) {
    const $tooltip = this.$tooltip;
    if (!$tooltip) return;
    const $tooltipContent = $tooltip.querySelector('.ToolTip__content');
    if (!$tooltipContent) return;
    if (typeof el === 'string') {
      $tooltipContent.innerHTML = el;
    } else if (typeof el === 'object') {
      $tooltipContent.innerHTML = '';
      $tooltipContent.appendChild(el);
    }
    this._resize();
  }

  _resize(element) {
    const $tooltipWrapper = (element || this.$tooltip).querySelector('.ToolTip__wrapper');
    if (!$tooltipWrapper) return;
    const $tooltipContent = $tooltipWrapper.querySelector('.ToolTip__content');
    let offsetHeight = $tooltipContent.offsetHeight;
    const style = getComputedStyle($tooltipContent);
    offsetHeight += parseInt(style.marginTop) + parseInt(style.marginBottom);
    $tooltipWrapper.style.height = `${offsetHeight}px`;
  }

  _toggle(event) {
    if (this.$tooltip && !this.$tooltip.classList.contains('ToolTip--closed')) {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = null;
      }
      event.preventDefault();
      this._close(event);
    } else {
      this._open(event);
      if (!this.resizeHandler) {
        this.resizeHandler = this._positionTooltip.bind(this);
        window.addEventListener('resize', this.resizeHandler);
      }
    }
  }

  _open(event) {
    const that = this;
    let open = true;
    helpers.privateMethods.closeOthers(this);
    if (!this.$tooltip) {
      this.$tooltip = this._createTooltip();
    }
    function openTooltip() {
      if (event) {
        event.preventDefault();
      }
      setTimeout(() => {
        that.removeClass(that.$tooltip, 'ToolTip--closed');
        const wrapper = that.$tooltip.querySelector('.ToolTip__wrapper');
        that.removeClass(wrapper, 'ToolTip__wrapper--closed');
        const arrow = that.$tooltip.querySelector('.ToolTip__arrow');
        that.removeClass(arrow, 'ToolTip__arrow--closed');
        that._resize();
        that._positionTooltip();
        if (that.options.closeOnClick) {
          document.addEventListener('click', that._documentClickListner.bind(that));
        }
      }, 36);
    }

    if (this.options.onOpen) {
      // Pass in content in case it needs to change
      this.options.onOpen(this.$tooltip.querySelector('.ToolTip__content'), result => {
        if (typeof result !== 'undefined') {
          open = result;
        }

        if (open) {
          openTooltip();
        }
      });
    } else {
      openTooltip();
    }

    return this;
  }

  _close() {
    if (this.options.closeOnClick) {
      document.removeEventListener('click', this._documentClickListner);
    }
    if (this.$tooltip) {
      const wrapper = this.$tooltip.querySelector('.ToolTip__wrapper');
      const arrow = this.$tooltip.querySelectorAll('ToolTip__arrow');
      this.addClass(wrapper, 'ToolTip__wrapper--closed');
      this.addClass(arrow, 'ToolTip__arrow--closed');
      this.addClass(this.$tooltip, 'ToolTip--closed');
      if (this.options.onClose) {
        this.options.onClose(this.$tooltip.querySelector('.ToolTip__content'));
      }
    }
  }

  destroy() {
    this._close();
    if (this.$tooltip) {
      helpers.privateMethods.removeNode(this.$tooltip);
    }
    this.$tooltip = null;
  }

  close() {
    this._close();
  }

  open() {
    this._open();
  }

  bottom(windowData, targetData, tooltipData, boxData) {
    return this._selectPosition(['bottom', 'top', 'right', 'left']);
  }

  top(windowData, targetData, tooltipData, boxData) {
    return this._selectPosition(['top', 'bottom', 'right', 'left']);
  }

  left(windowData, targetData, tooltipData, boxData) {
    return this._selectPosition(['left', 'right', 'bottom', 'top']);
  }

  right(windowData, targetData, tooltipData, boxData) {
    return this._selectPosition(['right', 'left', 'bottom', 'top']);
  }
  // _top: function _top(){
  //   this.top();
  // }

  static tooltip($element, opt) {
    const args = Array.prototype.slice.call(arguments, 1);
    const elements = document.querySelectorAll('#' + $element.getAttribute('id'));
    const data = helpers.privateMethods.datareturntooltip();

    for (const element of elements) {
      let instance;
      if (!instance) {
        if (opt !== 'close') {
          data.set(element, { ToolTip: new ToolTip(element, opt) });
        }
      }
      instance = data.get(element).ToolTip;
      if (instance) {
        if ((typeof opt === 'string') && (instance[opt])) {
          instance[opt](...args);
        }
      }
    }
  }
}

module.exports = {
  tooltip
}



//////////////////
// WEBPACK FOOTER
// /Users/pxm847m/git/global-tooltip/source/js/main.js
// module id = 0
// module chunks = 0